// Analytics event name constants — single source of truth for Mixpanel event names
export const AnalyticsEvents = {
  PROJECT_CREATED: 'Project Created',
  PROJECT_DELETED: 'Project Deleted',
  PROJECT_CLONED: 'Project Cloned',
  NODE_EXECUTED: 'Node Executed',
  NODE_CONFIG_UPDATED: 'Node Config Updated',
  CHAT_MESSAGE_SENT: 'Chat Message Sent',
  STORY_EXPANDED: 'Story Expanded',
  STORY_REFINED: 'Story Refined',
  CHARACTER_GENERATED: 'Character Generated',
  LOCATION_GENERATED: 'Location Generated',
  VIDEO_GENERATED: 'Video Generated',
  COVER_GENERATED: 'Cover Generated',
  PUBLISHED_TO_SHOWCASE: 'Published to Showcase',
} as const

export type AnalyticsEvent = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents]
